export var INVEST_TRANSFER_DIGITAL_ELIGIBLE = ['I1', 'I2', 'I6'];
export var INVEST_TRANSFER_PAPER_FORM = ['B1', 'I3', 'I4', 'I5', 'P4'];
export var WEALTH_ACCOUNT_TYPE = 'INVW';
//# sourceMappingURL=invest.js.map